import React, { useEffect, useState } from "react";
import { UpdateReportEntryModel, reportApi } from "../api/reportApi";
import { Problem } from "../api/backendApi";
import ErrorDisplay from "../common/ErrorDisplay";
import LoadingDisplay from "../common/LoadingDisplay";
import { Dropdown, Table } from "react-bootstrap";
import { Check } from "react-bootstrap-icons";

function UpdateReportPage() {
  const [entries, setEntries] = useState<UpdateReportEntryModel[]>();
  const [filteredEntries, setFilteredEntries] =
    useState<UpdateReportEntryModel[]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Problem>();
  const [changeFilter, setChangeFilter] = useState<string>();

  useEffect(() => {
    async function loadReport() {
      setLoading(true);
      const result = await reportApi.getUpdateReport();
      setLoading(false);

      if (result.ok) {
        setError(undefined);
        setEntries(result.value);
        applyFilters(result.value, changeFilter);
      } else {
        setError(result.problem);
        setEntries(undefined);
      }
    }

    loadReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyFilters = (
    entries: UpdateReportEntryModel[],
    changeFilter: string | undefined,
  ) => {
    const filtered = (entries ?? []).filter((e) => {
      if (changeFilter === "M" && !e.hasModelInfoChanges) {
        return false;
      }

      if (
        changeFilter === "C" &&
        (!e.hasCrsDataFileChanges || e.isCheckedOut || !e.hasModelInfo)
      ) {
        return false;
      }

      return true;
    });

    setFilteredEntries(filtered);
  };

  const handleSetChangeFilter = (filter: string | undefined) => {
    setChangeFilter(filter);
    applyFilters(entries ?? [], filter);
  };

  return (
    <>
      <div className="main-container-title">
        <h1>Update Report</h1>
        <ErrorDisplay error={error} />
      </div>
      <div className="main-container-content">
        <LoadingDisplay loading={loading} />
        {!loading && (
          <div className="fixed-table-header" style={{ height: "auto" }}>
            <Table bordered>
              <thead>
                <tr>
                  <th style={{ width: "1px" }}>Number</th>
                  <th style={{ width: "1px" }}>Type</th>
                  <th style={{ width: "1px" }}>New</th>
                  <th style={{ width: "1px" }}>RSA</th>
                  <th>Description</th>
                  <th>Regions</th>
                  <th style={{ width: "1px", whiteSpace: "nowrap" }}>
                    <Dropdown>
                      <Dropdown.Toggle variant="default">
                        {changeFilter === "M" && "Only with Model Info changes"}
                        {changeFilter === "C" && "Only checked in CRS files"}
                        {!changeFilter && "All changes"}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => handleSetChangeFilter(undefined)}
                        >
                          All
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleSetChangeFilter("C")}
                        >
                          Only checked in CRS Files
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleSetChangeFilter("M")}
                        >
                          Only Model Info
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!entries && (
                  <tr>
                    <td colSpan={6}>Loading...</td>
                  </tr>
                )}
                {entries?.length === 0 && (
                  <tr>
                    <td colSpan={6}>No data...</td>
                  </tr>
                )}
                {filteredEntries &&
                  !error &&
                  filteredEntries.map((e) => (
                    <tr key={e.number}>
                      <td>{e.number}</td>
                      <td>{e.type}</td>
                      <td style={{ textAlign: "center" }}>
                        {e.isNew && <Check />}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {e.isRsa && <Check />}
                      </td>
                      <td>{e.description}</td>
                      <td style={{ width: "20%" }}>{e.regions.join(" / ")}</td>
                      <td className="text-center text-nowrap">
                        {e.hasCrsDataFileChanges && "CRS File"}
                        {e.hasCrsDataFileChanges &&
                          e.hasModelInfoChanges &&
                          "/"}
                        {e.hasModelInfoChanges && "Model Info"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </>
  );
}

export default UpdateReportPage;
